<template>
    <PageContainer>
        <div class="row">
            <div class="col-12">
                <CustomerPreview :customer="customer"/>
                <div class="row my-5">
                    <div class="col-md-4">
                        <PreviewSidePanel
                            class="mb-3"
                            v-if="getDelivered.length"
                            :title="$t('issueLog.type.delivered')"
                            :items="getDelivered"
                        />
                        <PreviewSidePanel
                            class="mb-3"
                            v-if="getDevolution.length"
                            :title="$t('issueLog.type.devolution')"
                            :items="getDevolution"
                        />
                    </div>
                    <div class="col-md-8">
                        <DevolutionProductForm
                            :customer="customer"
                            :allItems="getAllItems"
                        />
                    </div>
                </div>
            </div>
        </div>
        <BackButton href="/scan/delivered" />
    </PageContainer>
</template>

<script setup lang="ts">
import PageContainer from "@/components/elements/PageContainer.vue";
import {computed} from "vue";
import type {
    CustomerInterface,
    IssuedLogInterface,
    QuantityInterface,
    SidePanelItemInterface
} from "@/components/helpers/Interfaces.ts";
import CustomerPreview from "@/components/elements/CustomerPreview.vue";
import PreviewSidePanel from "@/components/elements/PreviewSidePanel.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import DevolutionProductForm from "@/components/widget/Forms/DevolutionProductForm.vue";

const {customer, quantities, logs} = defineProps<{
    customer: CustomerInterface,
    quantities: QuantityInterface[],
    logs: IssuedLogInterface[]
}>()

const getAllItems = computed((): IssuedLogInterface[] => {
    if (!logs) {
        return [];
    }
    return logs
})

const getDelivered = computed(() => {
    const all: SidePanelItemInterface[] = []
    if (!logs) {
        return all;
    }
    const items = logs.filter(item => item.issue_type.toLowerCase() === 'delivered')
    items.map(item => {
        item.items.map(logItem => {
            all.push({
                id: logItem.id,
                name: `${logItem.product.name} (${logItem.size.size})`,
                quantity: logItem.quantity
            })
        })
    })

    return all
})
const getDevolution = computed(() => {
    const all: SidePanelItemInterface[] = []
    if (!logs) {
        return all;
    }
    const items = logs.filter(item => item.issue_type.toLowerCase() === 'devolution')
    items.map(item => {
        item.items.map(logItem => {
            all.push({
                id: logItem.id,
                name: logItem.product.name,
                quantity: logItem.quantity
            })
        })
    })

    return all
})
</script>

<style scoped>
</style>
